import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const MedicationIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color="none" width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7467 10.5224V5.01153C10.7467 2.90579 8.77925 1.18164 6.37635 1.18164H5.37037C2.96587 1.18164 1 2.90579 1 5.01153V10.5224H10.7467Z"
        fill={color}
      />
      <path
        d="M10.3154 15.0827V4.90132C10.3154 2.75606 8.52276 1 6.33122 1H5.41583C3.22429 1 1.43164 2.75606 1.43164 4.90132V16.009C1.43164 18.1558 3.22429 19.9119 5.41583 19.9119H6.33122C7.53744 19.9119 8.61811 19.3779 9.34439 18.5388"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5789 13.5179C17.7287 11.4551 15.65 10.0229 13.2487 10.1039C10.1783 10.2066 7.77537 12.727 7.88026 15.7332C7.88821 15.9839 7.93906 16.2205 7.98038 16.4618L18.5789 13.5179Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32227 17.6453C9.18998 19.6722 11.2528 21.0718 13.6287 20.9924C16.6991 20.8896 19.102 18.3676 18.9971 15.3615C18.9891 15.1357 18.9415 14.9224 18.9065 14.7061L8.32227 17.6453Z"
        fill={color}
      />
    </IconBase>
  );
};

export default MedicationIcon;
